import React, { useEffect, useState } from "react";
import {
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
  FaFacebookF,
} from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import { TfiTimer } from "react-icons/tfi";
import { Button } from "../components/ui/button";
import { cn } from "../lib/utils";

const TopHeader = ({ onScheduleClick }) => {
  const [showTopBar, setShowTopBar] = useState(true);

  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();

  const days = [
    { name: "Sun", open: false },
    { name: "Mon", open: true },
    { name: "Tue", open: true },
    { name: "Wed", open: true },
    { name: "Thu", open: true },
    { name: "Fri", open: true },
    { name: "Sat", open: true },
  ];

  const today = days[day];
  const isOpen = today.open && hour >= 9 && hour < 19;

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const scrollDelta = currentScrollY - lastScrollY;

      if (window.innerWidth >= 1024) {
        if (scrollDelta > 30 && currentScrollY > 100) {
          setShowTopBar(false);
        } else if (scrollDelta < -30 || currentScrollY < 60) {
          setShowTopBar(true);
        }
        lastScrollY = currentScrollY;
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={cn(
        "hidden lg:flex justify-center bg-gradient-to-r from-secondary/90 to-secondary/70 backdrop-blur-sm border-b border-border/50 w-full text-foreground items-center overflow-hidden transition-all duration-300 ease-in-out",
        showTopBar ? "opacity-100 translate-y-0 h-12" : "opacity-0 -translate-y-full h-0"
      )}
    >
      <div className="container flex justify-between items-center text-xs md:text-sm">
        <div className="flex gap-4 md:gap-6">
          <a
            href="https://maps.google.com/?q=Hoshangabad+Road+Bhopal"
            target="_blank"
            rel="noopener noreferrer"
            className="flex gap-1.5 items-center text-muted-foreground hover:text-primary transition-colors group"
          >
            <FaLocationDot className="text-primary group-hover:scale-110 transition-transform" />
            <span className="group-hover:underline">Hoshangabad Road, Bhopal - 462026</span>
          </a>
          <a
            href="mailto:admin@oethical.com"
            className="flex gap-1.5 items-center text-muted-foreground hover:text-primary transition-colors group"
          >
            <MdOutlineEmail className="text-primary group-hover:scale-110 transition-transform" />
            <span className="group-hover:underline">admin@oethical.com</span>
          </a>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex gap-1.5 items-center text-muted-foreground">
            <TfiTimer className="text-primary" />
            <span>
              <span className={cn(
                "font-medium",
                isOpen ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"
              )}>
                {isOpen ? "Open Now" : "Closed"}
              </span>
              {" "}⋅ {today.name}: {today.open ? "09:00 am - 7:00 pm" : "Closed"}
            </span>
          </div>
          <div className="flex gap-1 items-center">
            {[
              { icon: FaWhatsapp, href: "https://wa.me/919532912517", label: "WhatsApp", color: "hover:text-green-600 dark:hover:text-green-400" },
              { icon: FaTwitter, href: "https://x.com/oethical_tech", label: "Twitter", color: "hover:text-blue-400" },
              { icon: FaInstagram, href: "https://www.instagram.com/oethicaltechnology/", label: "Instagram", color: "hover:text-pink-500" },
              { icon: FaLinkedinIn, href: "https://www.linkedin.com/company/oethical-technology/", label: "LinkedIn", color: "hover:text-blue-600 dark:hover:text-blue-400" },
              { icon: FaFacebookF, href: "https://www.facebook.com/profile.php?id=61580082270577", label: "Facebook", color: "hover:text-blue-600 dark:hover:text-blue-400" },
            ].map(({ icon: Icon, href, label, color }) => (
              <a
                key={label}
                target="_blank"
                rel="noopener noreferrer"
                href={href}
                className={cn(
                  "text-muted-foreground transition-all p-2 hover:bg-accent rounded-md",
                  color
                )}
                aria-label={label}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <Button
            onClick={onScheduleClick}
            size="sm"
            className="text-xs"
          >
            Schedule Demo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TopHeader;
